const touchInQueryParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).has('touch') : false;

const needsBigButtons = typeof window !== 'undefined' && (matchMedia('(pointer: coarse)').matches || touchInQueryParams);

const gridSize = 10;

// LAYOUT2 is all in pixels; Use JavaScript numbers, not strings.
export const LAYOUT2 = {
  minButtonHeight: needsBigButtons ? 45 : 30,
  smallButtonHeight: needsBigButtons ? 45 : 30,
  mediumButtonHeight: needsBigButtons ? 45 : 40,
  largeButtonHeight: 50,
  spacing: gridSize,
  spacingHalf: gridSize / 2,
  spacingQuarter: gridSize / 4,
  spacingP5: gridSize / 2,
  spacing1: gridSize,
  spacing1p5: gridSize * 1.5,
  spacing2: 2 * gridSize,
  spacing2p5: 2.5 * gridSize,
  spacing3: 3 * gridSize,
  spacing3p5: 3.5 * gridSize,
  spacing4: 4 * gridSize,
  spacing4p5: 4.5 * gridSize,
  spacing5: 5 * gridSize,
  spacing6: 6 * gridSize,
  spacing7: 7 * gridSize,
  spacing8: 8 * gridSize,
  spacing9: 9 * gridSize,
  spacing10: 10 * gridSize,
  spacing11: 11 * gridSize,
  spacing12: 12 * gridSize,
  spacing13: 13 * gridSize,
  spacing14: 14 * gridSize,
  spacing15: 15 * gridSize,
  spacing16: 16 * gridSize,
  spacing17: 17 * gridSize,
  spacing18: 18 * gridSize,
  spacing19: 19 * gridSize,
  spacing20: 20 * gridSize,

  leftNavWidth: 28 * gridSize,
  topBarHeight: 6 * gridSize,
};
